import { render, staticRenderFns } from "./DialogCouponHistory.pug?vue&type=template&id=f060a10a&scoped=true&lang=pug&"
import script from "./DialogCouponHistory.vue?vue&type=script&lang=js&"
export * from "./DialogCouponHistory.vue?vue&type=script&lang=js&"
import style0 from "./DialogCouponHistory.scss?vue&type=style&index=0&id=f060a10a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f060a10a",
  null
  
)

export default component.exports